import {useReadFaq, useReadProductCategory} from "../../hooks";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useCallback, useState} from "react";
import {useEditFaq} from "../../hooks/useEditFaq";
import {PaginationMain} from "../../../../../components/common/pagination/PaginationMain";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import {useUser} from "../../../../../util/userContext/UserContext";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

export const SearchTable = () => {
    const {res} = useReadFaq();
    const {data: categoryData} = useReadProductCategory();
    const {user} = useUser();
    const {data} = res;
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const pageNo = Number(searchParams.get("pageNo")) || 1;

    const {deleteFaq} = useEditFaq();
    const [checkboxArr, setCheckboxArr] = useState<string[]>([]);

    const isAllCheck = data?.faqList?.length !== 0 && data?.faqList?.map(el => el.faqId).every(el => checkboxArr.includes(el));

    const clickAllCheck = () => {
        if (isAllCheck) {
            const list = checkboxArr.filter(el => !data?.faqList.map(el => el.faqId).includes(el))

            setCheckboxArr(list)
        } else {
            // @ts-ignore
            const list = [...new Set([...checkboxArr, ...data?.faqList.map(el => el.faqId)])]

            setCheckboxArr(list)
        }
    }

    const clickCheck = (el: any) => {
        if (checkboxArr.includes(el.faqId)) {
            const list = checkboxArr.filter(el2 => el.faqId !== el2)

            setCheckboxArr(list)
        } else {
            setCheckboxArr([...checkboxArr, el.faqId])
        }
    }

    const getIsNoticeTxt = useCallback((isNotice: string | undefined) => {
        switch (isNotice) {
            case 'Y':
                return '공지';
            case 'N':
                return '일반';
            case 'U':
                return '비활성화';
            default:
                return '';
        }
    }, []);

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">
                FAQ 목록(<span>{data?.totalCount ?? 0}</span>건)
            </h6>
            <div className="table_toolbar">
                <AuthorityChecker authorityNames={['faqWriteYn']}>
                    <button
                        className="btn btn-dark w-80px"
                        onClick={() => navigate(`${process.env.PUBLIC_URL}/support/faq/create`)}>
                        추가
                    </button>
                    <button className="btn btn-outline-dark w-100px px-0"
                            onClick={() => deleteFaq({faqIdList: checkboxArr})}>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"}
                            alt=""
                        />
                        선택삭제
                    </button>
                </AuthorityChecker>
            </div>
        </div>
        {/* 내부수정: table_scroll 삭제 */}
        <table className="table table-bordered my_table">
            <thead>
            <tr>
                <AuthorityChecker authorityNames={['faqWriteYn']}>
                    <th rowSpan={2} style={{width: "4.4%"}}>
                        <div className="checkbox_outer">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isAllCheck}
                                onClick={clickAllCheck}/>
                        </div>
                    </th>
                </AuthorityChecker>
                <th style={{width: "7.5%%"}} rowSpan={2}>
                    No
                </th>
                <th style={{width: "10.06"}} rowSpan={2}>
                    유형
                </th>
                <th style={{width: "22.64%"}} colSpan={3}>
                    제품
                </th>
                <th style={{width: "42.1%"}} rowSpan={2}>
                    제목
                </th>
                <th rowSpan={2}>구분</th>
            </tr>
            <tr>
                <th style={{width: "11.32%"}}>벤더</th>
                <th style={{width: "11.32%"}}>카테고리</th>
                <th style={{width: "11.32%"}}>제품군</th>
            </tr>
            </thead>
            <tbody>
            {(data?.faqList ?? []).map((item, index) => (
                <tr
                    className={checkboxArr.includes(item.faqId) ? "lightblue clickable" : "clickable"}
                    onClick={() => navigate(`${process.env.PUBLIC_URL}/support/faq/detail/${item.faqId}`)}>
                    <AuthorityChecker authorityNames={['faqWriteYn']}>
                        <td className="text-center">
                            <div className="checkbox_outer">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={checkboxArr.includes(item.faqId)}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        clickCheck(item)
                                    }}
                                />
                            </div>
                        </td>
                    </AuthorityChecker>
                    <td className="text-center">{(pageNo - 1) * 10 + 1 + index}</td>
                    <td className="text-center">{item.topicType}</td>
                    <td className="text-center">{item.productVendor}</td>
                    <td className="text-center">{item.productCategory}</td>
                    <td className="text-center">{item.newName}</td>
                    {/* 내부수정: 파일 첨부, 경고 빨강
                    <td>{item?.title ?? ''}</td>
                    <td className="text-center">{getIsNoticeTxt(item.isNotice)}</td> */}
                    <td>
                        <span>{item?.title ?? ''}</span>
                        {item.hasAttachment &&
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/icon_attachment.png"}
                                alt="첨부파일"
                                style={{ width: "16px", marginLeft: "6px", verticalAlign: "middle" }}
                            />
                        }
                    </td>
                    <td className="text-center">
                        <span className={item.isNotice === 'Y' ? 'requiredBlue' : ''}>
                            {getIsNoticeTxt(item.isNotice)}
                        </span>
                    </td>
                </tr>
            ))}
            {(data?.faqList.length ?? 0) === 0 && <EmptyTableRow/>}
            </tbody>
        </table>
        <PaginationMain totalCount={data?.totalCount ?? 0}/>
    </div>
}